export default __webpack_public_path__ + "static/artists2-5d5bdad51e95504beaf150ba5e1d08e7.jpg";